module.exports = __webpack_public_path__ + "img/Weapon_28.e0a3e1ab.png";